module.exports = __webpack_public_path__ + "img/earth.e15eb8d2.jpg";